import { AppRouteProps } from "@bsm/component";
import EmailConfigureContainer from "./container/EmailConfigureContainer";

export const EmailConfigureRoutes: Array<AppRouteProps> = [
    {
        path: "configure",
        element: <EmailConfigureContainer />,
    },
];